export default __webpack_public_path__ + "static/media/igor.7430b261.jpg";